module.exports = __webpack_public_path__ + "img/tutorial7.34a6777c.png";